<template>
  <div class="page-slot">
    <div class="page-slot-data p-2" v-if="!data.data.load">
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-form-group
          v-if="data.data.save"
          class="text-capitalize"
          :label="$t('pages.description')"
          label-for="description"
        >
          <b-form-input id="description" v-model="data.data.description" trim />
        </b-form-group>
        <b-form-group
          class="text-capitalize"
          :label="$t('grid.frame.url')"
          label-for="url"
        >
          <b-form-input id="url" v-model="data.data.url" trim />
        </b-form-group>
        <validation-provider
          #default="validationContext"
          name="facilities"
          rules="required"
        >
          <b-form-group
            v-if="data.data.save"
            :label="$t('pages.facilities')"
            :state="getValidationState(validationContext)"
          >
            <v-select
              v-model="data.data.facility_id"
              :options="facilityOpts"
              :clearable="true"
              :reduce="(val) => val.value"
              input-id="id_unit"
              :multiple="false"
            />
            <b-form-invalid-feedback :state="getValidationState(validationContext)">
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <b-form-checkbox
          v-if="data.data.save"
          id="linkSharedCheckbox"
          v-model="data.data.shared"
          name="shared"
          value="1"
          class="my-1 text-capitalize"
          unchecked-value="0"
          switch
        >
          {{ $t("pages.shared") }}
        </b-form-checkbox>
        <!-- Form Actions -->
        <div class="d-flex mt-2" v-if="data.data.save">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2 text-capitalize"
            type="button"
            @click="handleSubmit(save)"
          >
            {{ $t("actions.save") }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="button"
            variant="secondary"
            @click="
              data.data.load = true;
              data.data.save = false;
            "
            class="text-capitalize"
          >
            {{ $t("actions.cancel") }}
          </b-button>
        </div>
        <b-button
          v-if="!data.data.save"
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          type="button"
          variant="secondary"
          @click="loadUrl()"
          class="text-capitalize"
        >
          {{ $t("actions.load") }}
        </b-button>
      </validation-observer>
    </div>
    <div v-if="data.data.load && !data.data.save" class="frame">
      <video v-if="isVideo" class="frame" loop autoplay muted controls>
        <source :src="data.data.url" type="video/mp4">
        Tu navegador no soporta videos.
      </video>
      <iframe v-else :src="data.data.url" class="frame" />
    </div>
  </div>
</template>

<script>
import { BFormInput, BFormGroup, BButton } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import store from "@/store";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  components: {
    BFormInput,
    BButton,
    BFormGroup,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    data: {
      type: Object,
    },
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      selectedFacility: null,
      facilityOptions: [],
      iframeKey: 0,
    };
  },
  methods: {
    loadUrl() {
      this.data.data.load = true;
    },
    reloadIframe() {
      this.data.data.load = false;
      this.$nextTick(() => {
        this.data.data.load = true;
      });
    },
    save() {
      const params = {
        description: this.data.data.description,
        id_unit: this.data.data.facility_id,
        url: this.data.data.url,
        shared: this.data.data.shared,
      };

      if (this.data.data.id) {
        store
          .dispatch("pages/edit", {
            id: this.data.data.id,
            params,
          })
          .then((response) => {
            this.data.data.id = response.data.id;
            this.data.data.load = true;
            this.data.data.save = false;
            store.commit("grid/resetTenants");
            store.dispatch("grid/resetUnits");
          });
      } else {
        store.dispatch("pages/add", params).then((response) => {
          this.data.data.id = response.data.id;
          this.data.data.load = true;
          this.data.data.save = false;
          store.commit("grid/resetTenants");
          store.dispatch("grid/resetUnits");
        });
      }
    },
    getValidationState({
      dirty,
      validated,
      required: fieldRequired,
      changed,
      valid = null,
    }) {
      const result = dirty || validated ? valid : null;
      return !fieldRequired && !changed ? null : result;
    },
  },
  computed: {
    units() {
      return store.getters["unit/getSelectedItems"];
    },
    facilityOpts() {
      if (this.facilityOptions.length) {
        return this.facilityOptions;
      }

      this.facilityOptions = [...this.units];

      return this.facilityOptions;
    },
    isVideo() {
      return /^http.*\.mp4$/.test(this.data.data.url);
    }
  },
  mounted() {
    if (this.data.data.url) {
      this.data.data.load = true;
    }

    if (!this.units.length) {
      store.dispatch("unit/getUnitsByTenant");
    }
  },
};
</script>

<style lang="scss" scoped>
.page-slot {
  width: 100%;
  height: 100%;
}

.page-slot-data {
  width: 100%;
  height: 100%;
}

.frame {
  width: 100%;
  height: 100%;
  border: none;
  overflow: hidden;
  z-index: 1;
  position: relative;
}
</style>
